module.exports = __webpack_public_path__ + "media/n06.6f1ac307.mp4";